module.exports = __webpack_public_path__ + "img/book.286ccc45.png";